var _defs, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLumosityCircleColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 52.8,
    x2: 24.747,
    y1: 0,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6533"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFAF4",
    fillRule: "evenodd",
    d: "m50.903 32.467-3.556-8.555c-2.426-6.864-7.664-11.943-14.9-12.108-8.628-.196-15.749 6.567-15.844 15.196-.053 4.744 1.997 8.991 5.28 12.315.61.616.794 1.535.464 2.337l-1.359 3.308a.416.416 0 0 0 .19.524l2.36 1.26 5.956-14.579 1.247-3.048h-9.325a1.75 1.75 0 0 1-1.762-1.75c0-6.646 5.17-12.244 11.808-12.541 7.094-.317 12.944 5.34 12.944 12.364v.151c0 .981-.795 1.776-1.776 1.776h-6.987a2.743 2.743 0 0 0-2.568 1.688L25.93 48.02l7.493 3.998c.216.115.484.02.579-.207l3.851-9.251 4.499-.002c3.612-.044 4.176-.741 4.176-4.498v-5.014l3.992-.003a.416.416 0 0 0 .384-.575Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFAF4",
    fillRule: "evenodd",
    d: "M31.986 14.813c-6.84.024-12.333 5.67-12.333 12.511v.042a1.75 1.75 0 0 0 1.762 1.751h9.326l5.536-13.556-.15-.05a12.359 12.359 0 0 0-4.141-.698Z",
    clipRule: "evenodd",
    opacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumosityCircleColor);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;